// @flow

import type {TreeStructure} from '../typedef';

export const mergeTrees = (tree1: TreeStructure, tree2: TreeStructure): TreeStructure => {
    return tree2.map(tree2Item => {
        const target = tree1.find(tree1Item => tree1Item.id === tree2Item.id);
        if (target) {
            if (tree2Item.children && target.children) {
                tree2Item.children = mergeTrees(target.children, tree2Item.children);
            }
            return {...target, ...tree2Item};
        } else {
            return tree2Item;
        }
    });
};
